import { Car, Briefcase, Hammer, Tractor, Building2, Home as HomeIcon, Shirt, Bike } from "lucide-react";

export const CATEGORY_CARDS = [
  { name: "Motors", icon: Car, img: "https://images.unsplash.com/photo-1521136095380-08fbd7be93c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", desc: "Cars, vans & bikes" },
  { name: "Jobs", icon: Briefcase, img: "https://images.unsplash.com/photo-1557425747-929b65a39785?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", desc: "Find your next role" },
  { name: "House & DIY", icon: Hammer, img: "https://images.unsplash.com/photo-1426927308491-6380b6a9936f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", desc: "Furniture & tools" },
  { name: "Farming", icon: Tractor, img: "https://images.unsplash.com/photo-1696441567908-6a04d49e1350?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", desc: "Machinery & livestock" },
  { name: "Lettings", icon: Building2, img: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", desc: "Apartments & houses to rent" },
  { name: "Property for Sale", icon: HomeIcon, img: "https://images.pexels.com/photos/164558/pexels-photo-164558.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", desc: "Homes & sites for sale" },
  { name: "Clothes & Fashion", icon: Shirt, img: "https://images.pexels.com/photos/1488470/pexels-photo-1488470.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", desc: "Clothes, shoes & accessories" },
  { name: "Sports & Leisure", icon: Bike, img: "https://images.unsplash.com/photo-1586349693524-574e28e7d276?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", desc: "Bikes & sports equipment" },
];

export function CategoryGrid({ onSelect }) {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 w-full">
      <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-slate-900 mb-6">Browse categories</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {CATEGORY_CARDS.map((c) => (
          <div key={c.name} data-testid={`category-card-${c.name}`} onClick={() => onSelect(c.name)}
            className="relative h-44 rounded-xl overflow-hidden cursor-pointer group border border-slate-200">
            <img src={c.img} alt={c.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/85 via-slate-900/30 to-transparent" />
            <div className="absolute bottom-0 left-0 p-4 text-white">
              <c.icon size={22} className="mb-1" />
              <h3 className="font-heading font-bold text-lg">{c.name}</h3>
              <p className="text-xs text-slate-200">{c.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
